import { type Content } from '@prismicio/client';
import { filter } from '@prismicio/client';
import { Category } from 'src/constants/Blog';

// Prismic has a bug where it doesn't set all existing values to false when a
// boolean field is set to false. Some of them are still set to null
export const EXCLUDED_FILTER = filter.not(
    'my.blog_page.exclude_from_knowledge_hub',
    true,
);

export const CATEGORY_GUIDES_FILTER = filter.at(
    'my.blog_page.category',
    'Category Guides',
);

export function getCategoryFilter(category: Category) {
    switch (category.type) {
        case 'vertical':
            return filter.at('my.blog_page.vertical', category.vertical);
        case 'subvertical':
            return filter.at('my.blog_page.subvertical', category.subVertical);
        case 'blogCategory':
            return filter.at('my.blog_page.category', category.category);
    }
}

export const getHeroImage = (post: Content.BlogPageDocumentData) => {
    const heroSlice = post.slices.find(
        (slice: Content.BlogPageDocumentDataSlicesSlice) =>
            slice.slice_type === 'blog_hero',
    ) as Content.BlogHeroSlice;

    return heroSlice?.primary.hero_image;
};

export const getTags = (post: Content.BlogPageDocumentData) => {
    const tagSlice = post.slices.find(
        (slice: Content.BlogPageDocumentDataSlicesSlice) =>
            slice.slice_type === 'tag',
    ) as Content.TagSlice;

    return tagSlice?.items ?? [];
};

export const getReadingTime = (post: Content.BlogPageDocumentData) => {
    const contentSlice = post.slices?.find(
        (slice: Content.BlogPageDocumentDataSlicesSlice) =>
            slice.slice_type === 'blog_reading_time',
    ) as Content.BlogReadingTimeSlice | undefined;

    return contentSlice?.primary?.reading_time
        ? `${contentSlice.primary.reading_time} min read`
        : '';
};
